export const transformNumber = (num) => num.toLocaleString("es-CO");

export const convertDecimalPower = (number, magnitude = "", decimalsToinclude = 0) => {
    const powers = ["", "K", "M", "G", "T", "P"];
    let index = 0;

    while (number >= 1000 && index < powers.length - 1) {
        number /= 1000;
        index++;
    }

    return `${number.toFixed(decimalsToinclude)}${powers[index]}${magnitude}`;
};
